<template>
  <div id="product-detail">
    <v-layout align-center justify-center :key="state.idx" row v-for="state in states" wrap>
      <v-flex sm4 xs7>
        <v-img
          contain
          :src="state.picture ? state.picture : require('@/assets/NoPicture.png')"
          width="100%"
        ></v-img>
      </v-flex>
      <v-flex pb-0 text-xs-center xs12>
        <div class="display-1 font-weight-bold">{{ state.name || '' }}</div>
      </v-flex>
      <v-flex pt-0 sm5 xs12>
        <ShopItemPrice :shopEditionProductItemId="state.idx" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const ShopItemPrice = () => import('./ShopItemPrice')
export default {
  name: 'product-detail',
  components: {
    ShopItemPrice
  },
  data() {
    return {}
  },
  computed: {
    shopEditionProductId() {
      return atob(this.$route.params.shopEditionProductId)
    },
    states() {
      return this.$store.getters['ShopEditionProductItem/getAll'].filter(
        item => item.shopEditionProductId == this.shopEditionProductId
      )
    }
  },
  mounted() {
    this.$store.dispatch('ShopEditionProductItem/fetch')
  }
}
</script>

<style lang="scss" scoped></style>
